import React from "react";

export default () => {
  return <p className="font-primary mt-9 text-center">ERROR 404</p>;
};
